import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';

const lang = '';

class Disclaimer extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '免責聲明',
      'sc': '免责声明',
      'en': 'Disclaimer'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      DisclaimerJSX(this)
    );
  }
}

const DisclaimerJSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className="main-content-container">
      <div className='main-content-inner-wrapper disclaimer'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '免責聲明',
                    'sc': '免责声明',
                    'en': 'Disclaimer'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>
        <Grid container spacing={0}>
        <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '有關不構成發售的免責聲明',
                    'sc': '有关不构成发售的免责声明',
                    'en': 'No Offer'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': '本網址所載的資料及任何意見﹐並不代表匯寶資本集團（「匯寶資本」）以主理人或代理人身分邀請或提請任何人士購買或沽售任何金融工具﹐或提供任何投資意見或服務。',
                    'sc': '本网址所载的资料及任何意见﹐并不代表汇宝资本集团（「汇宝资本」）以主理人或代理人身分邀请或提请任何人士购买或沽售任何金融工具﹐或提供任何投资意见或服务。',
                    'en': `Neither the information nor any opinions contained in this site constitutes a solicitation or offer by the FxHB Group Company Limited（ "FxHB Group"）
                          to buy or sell, whether as principal or agent, any securities, futures, options or other financial instruments or provide any service or investment advice.`
                })
              }
            </p>
          </Grid>

          <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '有關保證的免責聲明',
                    'sc': '有关保证的免责声明',
                    'en': 'No Warranty'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': `本網址所載之資料﹐均來自匯寶資本認為可靠的來源﹐或以此等來源為依據。但匯寶資本不能﹐亦不會就任何資料或數據的準確性、有效性、及時性或完整性作出任何保證。
                          匯寶資本明確地拒絕承認任何商業保護﹐或某特定目的之適當性或承擔任何責任。本網址上的資料﹐僅按當時情況而提供﹐其所包含或表達的一切資料或意見﹐如有任何變更﹐恕不預先通知。`,
                    'sc': `本网址所载之资料﹐均来自汇宝资本认为可靠的来源﹐或以此等来源为依据。但汇宝资本不能﹐亦不会就任何数据或数据的准确性、有效性、及时性或完整性作出任何保证。
                          汇宝资本明确地拒绝承认任何商业保护﹐或某特定目的之适当性或承担任何责任。本网址上的数据﹐仅按当时情况而提供﹐其所包含或表达的一切数据或意见﹐如有任何变更﹐恕不预先通知。`,
                    'en': `Although the information on this site is obtained or compiled from sources believed to be reliable, FxHB Group cannot and does not warrant the accuracy, 
                          validity, timeliness or completeness of any such information. FxHB Group expressly disclaims any warranties of merchantability 
                          or fitness of a particular purpose or duties of care. All information on this site is provided "as is", and is subject to change without prior notice.`
                })
              }
            </p>
          </Grid>

          <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '有關責任限制的免責聲明',
                    'sc': '有关责任限制的免责声明',
                    'en': 'Limitation of Liability'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': `若因本網址出現任何失效或中斷情況﹐或任何其他人士的行為或疏忽﹐導致閣下不能連接或使用本網址或所載資料而蒙受任何直接、間接、特殊、相應或連帶的損失﹐
                          此等損失包括(但不限於)由任何第三者的行為或疏忽所導致﹐匯寶資本及其任何成員一概不會承擔任何責任﹐即使匯寶資本或其任何成員事先獲悉有招致此等損失的可能。`,
                    'sc': `若因本网址出现任何失效或中断情况﹐或任何其他人士的行为或疏忽﹐导致阁下不能连接或使用本网址或所载数据而蒙受任何直接、间接、特殊、相应或连带的损失﹐
                          此等损失包括(但不限于)由任何第三者的行为或疏忽所导致﹐汇宝资本及其任何成员一概不会承担任何责任﹐即使汇宝资本或其任何成员事先获悉有招致此等损失的可能。`,
                    'en': `In no event will any member of the FxHB Group be liable or have any responsibility for damages of any kind, 
                          whether direct, indirect, special, consequential or incidental, resulting from access or use of, or inability to access or use, 
                          this site or any sites or pages linked to this site, including (without limitation) damages resulting from the act or omission of any third party, 
                          even if any member of the FxHB Group has been advised of the possibility thereof.`
                })
              }
            </p>
          </Grid>

          <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '有關使用連接的免責聲明',
                    'sc': '有关使用连接的免责声明',
                    'en': 'Use of Links'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': `若瀏覽者通過本網址的連結功能離開本網址﹐並瀏覽並非由匯寶資本提供的內容﹐有關風險由瀏覽者自行承擔。若因該等網址所提供的服務、資料
                          或其他內容有任何延誤、缺失或遺漏而引致的虧損或損失﹐不論是實際或是聲稱的虧損或損失﹐亦不論是相應性或因受罰引致的虧損或損失﹐匯寶資本概不承擔任何責任。
                          匯寶資本對任何第三者傳送的任何電子內容﹐包括但不限於任何電子內容的準確性、主旨、質量或及時性﹐概不作出任何保證或聲明﹐亦不承擔任何責任。`,
                    'sc': `若浏览者通过本网址的链接功能离开本网址﹐并浏览并非由汇宝资本提供的内容﹐有关风险由浏览者自行承担。若因该等网址所提供的服务、数据
                          或其他内容有任何延误、缺失或遗漏而引致的亏损或损失﹐不论是实际或是声称的亏损或损失﹐亦不论是相应性或因受罚引致的亏损或损失﹐汇宝资本概不承担任何责任。
                          汇宝资本对任何第三者传送的任何电子内容﹐包括但不限于任何电子内容的准确性、主旨、质量或及时性﹐概不作出任何保证或声明﹐亦不承担任何责任。                    `,
                    'en': `Should the viewer leave this site via a link contained herein, and view content that is not provided by the FxHB Group, 
                          the viewer does so at its own risk. FxHB Group is not responsible for damages or losses caused by any delays, defects or omissions 
                          that may exist in the services, information or other content provided in such site, whether actual, alleged, consequential or punitive. 
                          FxHB Group makes no guarantees or representations as to, and shall have no liability for, any electronic content delivered by any third party 
                          or have any responsibility, including without limitation, the accuracy, subject matter, quality or timeliness of any electronic content.`
                })
              }
            </p>
          </Grid>

          <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '有關版權的免責聲明',
                    'sc': '有关版权的免责声明',
                    'en': 'Copyright'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': `本網址所提供的任何資料﹐若沒有得到匯寶資本的預先書面同意﹐均不可以透過任何方式或形式複製、傳送、傳播、出售、分發、出版、廣播、傳閱、貯存作其後使用或作任何商業用途。`,
                    'sc': `本网址所提供的任何数据﹐若没有得到汇宝资本的预先书面同意﹐均不可以透过任何方式或形式复制、传送、传播、出售、分发、出版、广播、传阅、贮存作其后使用或作任何商业用途。                    `,
                    'en': `The information on this site may not be copied, transmitted, disseminated, sold, distributed, published, broadcasted, circulated, stored 
                          for subsequent use or commercially exploited in any manner without the prior written consent of FxHB Group.`
                })
              }
            </p>
          </Grid>

          <Grid item id='grid-section' xs={12}>
            <h1>
              {
                ctx.getLangText({
                    'tc': '重要事項',
                    'sc': '重要事项',
                    'en': 'Important'
                })
              }
            </h1>
            <p>
              {
                ctx.getLangText({
                    'tc': `閣下於瀏覽本網站及其任何內頁﹐即表示已同意上述的合約條款。`,
                    'sc': `阁下于浏览本网站及其任何内页﹐即表示已同意上述的合约条款。`,
                    'en': `By accessing this site and any of its pages you are agreeing the terms and conditions set out above.`
                })
              }
            </p>
          </Grid>

        </Grid>
      </div>
    </div>
  </div>
)

export default Disclaimer



// WEBPACK FOOTER //
// ./src/components/pages/Disclaimer.js